import type {AddMaterialFunctionFormPayload} from "./add-material-function.schema";

import {addMaterialFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../../../material-keys";

export function addMaterialFunctionMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: materialMutationKeys.addMaterialFunction,
    mutationFn: (payload: AddMaterialFunctionFormPayload) => addMaterialFunction(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialKeys.detail(id)}),
        client.invalidateQueries({queryKey: materialKeys.lists()}),
      ]);
    },
  });
}
